import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";

import {
  CancelButton,
  CreateButtonLoading,
} from "../pages/css components/Button";

export default function SubmitButtons({
  ID = "",
  disabled = false,
  editState,
  setEditState,
  formikProps,
  route = "",
}) {
  const navigate = useNavigate();

  //   if (!!editState && !!setEditState && !!formikProps) {
  //     return "";
  //   }

  return (
    <Grid container spacing={2}>
      {!editState && (
        <Grid size="auto">
          <CancelButton variant="outlined" onClick={() => navigate(-1)}>
            Back
          </CancelButton>
        </Grid>
      )}

      {!!editState && (
        <Grid size="auto">
          <CreateButtonLoading
            type="submit"
            variant="contained"
            fullWidth
            onClick={formikProps.handleSubmit}
            disabled={!formikProps.dirty || !formikProps.isValid || disabled}
            loading={formikProps.isSubmitting}
            color="primary"
            sx={{
              "&.Mui-disabled": {
                background: "#eaeaea",
                color: "#c0c0c0",
              },
            }}
          >
            Submit
          </CreateButtonLoading>
        </Grid>
      )}

      {!!editState && (
        <Grid size="auto">
          <CancelButton
            variant="outlined"
            disabled={formikProps.isSubmitting}
            onClick={() => {
              if (editState && !!ID) {
                setEditState(!editState);
              }
            }}
          >
            Cancel
          </CancelButton>
        </Grid>
      )}
    </Grid>
  );
}
